import Map from 'ol/Map'
import View from 'ol/View'
import * as defs from 'ol/control'
import * as ints from 'ol/interaction'
import Kinetic from 'ol/Kinetic'
import Collection from 'ol/Collection'
import Interaction from 'ol/interaction/Interaction'
import OlAttribution from 'ol/control/Attribution'
import OlMouseWheelZoom from 'ol/interaction/MouseWheelZoom'
import OlDragPan from 'ol/interaction/DragPan'
import OlControl from 'ol/control/Control'

const Attribution = (options: any): OlAttribution => {
  return new (defs as any).Attribution(options)
}

const MouseWheelZoom = (options: any): OlMouseWheelZoom => {
  return new (ints as any).MouseWheelZoom(options)
}

const DragPan = (options: any): OlDragPan => {
  return new (ints as any).DragPan(options)
}

interface IDefaultControlsCollection {
  extend: (controls: any[]) => Collection<OlControl> | OlControl[]
}

const defaultControlsFunc = (options: any): IDefaultControlsCollection => {
  return {
    extend() {
      return []
    }
  } as IDefaultControlsCollection
}
const defaultControls = (defs as any).defaults as typeof defaultControlsFunc

interface IDefaultInteractionsCollection {
  extend: (controls: any[]) => Collection<Interaction> | Interaction[]
}

const defaultInteractionsFunc = (options: any): IDefaultInteractionsCollection => {
  return {
    extend() {
      return []
    }
  } as IDefaultInteractionsCollection
}
const defaultInteractions = (ints as any).defaults as typeof defaultInteractionsFunc

export {Map, View, Attribution, defaultControls, defaultInteractions, MouseWheelZoom, DragPan, Kinetic}
